module.exports = __webpack_public_path__ + "img/ic-logo-christmas-dark.b7ada8f3.svg";